import { useEffect, useRef, useState } from 'react';
import axiosConn from '../../axiosConn';

export default function useBohoRequest() {
  const [enabled, setEnabled] = useState(false);
  const [state, setState] = useState({ phase: 'editing' });
  const attempt = useRef(null);
  const busy = useRef(false);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    axiosConn.get('boho-florals/availability').then(({ data }) => {
      if (mounted.current) setEnabled(data?.data?.enabled === true);
    }).catch(() => {});
    return () => { mounted.current = false; };
  }, []);
  const send = async () => {
    if (!enabled || busy.current || !attempt.current) return;
    busy.current = true;
    setState({ phase: 'saving' });
    try {
      const { data } = await axiosConn.post('boho-florals/requests', attempt.current);
      if (data?.data?.received !== true || !/^[a-f0-9]{24}$/i.test(data?.data?.id || '')) throw new Error('Invalid receipt');
      if (mounted.current) setState({ phase: 'success' });
    } catch (error) {
      const status = error.response?.status;
      // Once receipt is uncertain, no later failure proves the first attempt was not saved.
      const rejected = state.phase !== 'retry' && (status === 400 || status === 409);
      if (rejected) attempt.current = null;
      if (mounted.current) setState({ phase: rejected ? 'editing' : 'retry', error: rejected
        ? 'Please check your details and try again. The request was not accepted.'
        : 'We could not confirm receipt. Retry to check or send the same request without duplicating it.' });
    } finally { busy.current = false; }
  };
  const submit = event => {
    event.preventDefault();
    if (!enabled || busy.current || state.phase === 'success') return;
    if (!attempt.current) {
      const data = Object.fromEntries(new FormData(event.currentTarget));
      try {
        data.submissionKey = Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
      } catch (_) { setState({ phase: 'editing', error: 'Secure submission is unavailable in this browser.' }); return; }
      attempt.current = data;
    }
    send();
  };
  return { enabled, state, submit, retry: send, locked: state.phase !== 'editing' };
}
